export enum Roles {
  "Product Owner" = "Product Owner",
  "Team Member" = "Team Member",
  "Scrum Master" = "Scrum Master",
  "Stakeholder" = "Stakeholder",
}
